module.exports = require("vuetify/lib/components/VDivider");